module.exports = "/images/clal.png?76e32ca6600050745907df4022fe613f";